<template>
    <el-main class="role-container" ref="role-container">
        <div class="role-content">
            <div class="search">
                <el-form :inline="true" :model="query" class="demo-form-inline">
                    <el-form-item>
                        <el-button-group>
                            <el-button type="danger" icon="el-icon-plus" @click="$refs.editForm.showDrawer('')">添加</el-button>
                        </el-button-group>
                    </el-form-item>
                    <el-form-item label="角色编号">
                        <el-input v-model="query.id" placeholder="角色编号" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="角色名称">
                        <el-input v-model="query.title" placeholder="角色名称" clearable></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" icon="el-icon-search" @click="doSearch">搜索</el-button>
                    </el-form-item>
                </el-form>
            </div>

            <div class="table-box">
                <el-table :data="tableData" style="width: 100%" :max-height="tableHeight" :height="tableHeight">
                    <el-table-column prop="id" label="编号" width="100"> </el-table-column>
                    <el-table-column prop="title" label="角色名称"> </el-table-column>
                    <el-table-column prop="auth_type" label="角色性质" width="100"> </el-table-column>
                    <el-table-column prop="sort" label="排序" width="160" align="center"> </el-table-column>
                    <el-table-column prop="is_valid" label="上/下线" width="160" align="center"> </el-table-column>
                    <el-table-column label="操作" width="200">
                        <template slot-scope="scope">
                            <el-button-group>
                                <el-button @click="$refs.editForm.showDrawer(scope.row)" type="primary" size="mini">编辑</el-button>
                                <el-button @click="deleteFn(scope.$index, scope.row)" type="danger" size="mini">删除</el-button>
                            </el-button-group>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <editForm ref="editForm" v-on:getTableData="getTableData"></editForm>

            <div class="footer-box">
                <div class="download"></div>
                <div class="pagination">
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pagination.page" :page-sizes="[15, 30, 50, 100]" :page-size="pagination.limit" layout="total, sizes, prev, pager, next, jumper" :total="pagination.total">
                    </el-pagination>
                </div>
            </div>
        </div>
    </el-main>
</template>

<script>
import editForm from './edit';

export default {
    namespaced: true,
    components: {
        editForm
    },
    data() {
        return {
            query: {
                id: "",
                title: ""
            },
            tableData: [],
            tableHeight: window.innerHeight - 230,
            pagination: {
                page: 1,
                limit: 15,
                total: 0
            }
        };
    },
    created: function () {
        this.getTableData();
    },
    methods: {
        getTableData() {
            //获取表格列表
            let that = this;
            let url = '/api/auth.role/index';
            let query = this.query;
            query.pagination = this.pagination;
            this.loading = true;
            this.$post(url, query).then(function (response) {
                let result = response.data;
                that.tableData = result.list;
                that.pagination = result.pagination;
                that.loading = false;
            });
        },
        doSearch() {
            // 搜索
            this.getTableData();
        },
        handleSizeChange(val) {
            this.pagination.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.pagination.page = val;
            this.getTableData();
        },
        deleteFn(index, e) {
            let _this = this;
            this.$confirm('此操作将, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    let url = '/api/auth.role/delete';
                    let query = {
                        id: e.id
                    };
                    this.loading = true;
                    this.$post(url, query).then(function (response) {
                        if (response.code == 200) {
                            _this.tableData.splice(index, 1);
                        }
                        _this.$message({
                            type: 'success',
                            message: response.msg
                        });
                    });
                })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });
                });
        }
    }
};
</script>

<style lang="less">
.role-container {
    height: 100%;
    padding: 12px;

    .role-content {
        height: 100%;

        .search {
            margin-left: 0;
        }

        .footer-box {
            margin-top: 6px;
            display: flex;
            align-items: center;

            .download {
                flex: 0 15%;
            }

            .pagination {
                margin: 0;
                flex: 1;
            }
        }
    }
}
</style>
